import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X, Handshake, BarChart3, AlertTriangle, TrendingUp, DollarSign } from 'lucide-react';

interface RencontreSACyberModalProps {
  isOpen: boolean;
  onClose: () => void;
}

type TabId = 'revenus-6mois' | 'clients-rendement' | 'produits' | 'clients-actifs' | 'roles-responsabilites' | 'gouvernance-sa-cyber';

const revenusMensuels = [
  { mois: 'Octobre 2025', revenus: '42 294 $' },
  { mois: 'Novembre 2025', revenus: '45 789 $' },
  { mois: 'Décembre 2025', revenus: '42 564 $' },
  { mois: 'Janvier 2026', revenus: '42 496 $' },
  { mois: 'Février 2026', revenus: '44 399 $' },
  { mois: 'Mars 2026', revenus: '44 569 $' },
];

const clientsRendement = [
  ['Atlantis Pompe', '34 608 $', '10.9%', 'Holistique 3 ans', 'Compte majeur à protéger et suivre en gouvernance.'],
  ['Flyscan', '24 500 $', '7.7%', 'Holistique 3 ans', 'Client stratégique à fort rendement.'],
  ['Gestion Légalis inc.', '21 463 $', '6.8%', 'Holistique 3 ans', 'Compte important avec potentiel de continuité.'],
  ['Hôtel Château Laurier Québec', '18 585 $', '5.9%', 'Holistique 3 ans', 'Client significatif à maintenir dans une approche proactive.'],
  ['Groupe Conseil DFM inc.', '18 566 $', '5.9%', 'Holistique 3 ans', 'Client stratégique dans le portefeuille actuel.'],
  ['Coopérative Funéraire des deux rives', '16 266 $', '5.1%', 'Holistique 3 ans', 'Client structurant avec potentiel PRIsME/gouvernance.'],
  ['AssurExperts', '11 139 $', '3.5%', 'Holistique 3 ans', 'Client à bon rendement récurrent.'],
  ['Tassé Bertrand Barabé Avocats inc.', '9 013 $', '2.8%', 'Holistique 3 ans', 'Client professionnel à maintenir en suivi actif.'],
  ['Consortium de recherche et d’innovation en bioprocédés industriels au Québec', '9 000 $', '2.8%', 'Holistique 3 ans', 'Client spécialisé avec valeur stratégique.'],
  ['Signature 4G', '8 990 $', '2.8%', 'À la carte', 'Revenu ponctuel important à convertir si possible.'],
  ['GDA Services Immobiliers Intégrés', '8 500 $', '2.7%', 'À la carte', 'Bon potentiel de conversion vers accompagnement récurrent.'],
  ['TB4 Ronam inc.', '7 820 $', '2.5%', 'Holistique 3 ans', 'Client récurrent à conserver dans la cadence.'],
  ['Ville de Saint-Lin-Laurentides', '7 000 $', '2.2%', 'Loi 25', 'Mandat conformité à potentiel de suite cyber.'],
  ['Unipêche MDM Ltée', '7 000 $', '2.2%', 'Loi 25', 'Client conformité avec possibilité de bonification.'],
  ['Paré Ouellet Bigaouette et Associés, Huissiers inc.', '6 042 $', '1.9%', 'Holistique 3 ans', 'Client récurrent à suivre.'],
  ['Atelier de préparation à l’emploi (A.P.E.) Inc.', '5 178 $', '1.6%', 'Holistique 3 ans', 'Client récurrent à potentiel de consolidation.'],
  ['Assurance Mutuelle des Fabriques de Québec', '5 040 $', '1.6%', 'Cyber 1 an', 'Client cyber annuel à surveiller pour renouvellement.'],
  ['CHUK FM', '5 000 $', '1.6%', 'À la carte', 'Mandat ponctuel avec potentiel de structuration TI.'],
  ['Archer', '5 000 $', '1.6%', 'À la carte', 'Client à fort potentiel stratégique.'],
  ['TJL Transport', '4 900 $', '1.5%', 'Loi 25', 'Mandat conformité.'],
  ['Abrasifs JJS inc.', '4 900 $', '1.5%', 'Loi 25', 'Mandat conformité.'],
  ['Alimentation FC', '4 687 $', '1.5%', 'Loi 25', 'Mandat conformité.'],
  ['Séminaire de Québec', '4 632 $', '1.5%', 'Loi 25', 'Mandat conformité.'],
  ['Groupe Gaétan Castonguay Inc', '4 206 $', '1.3%', 'Loi 25', 'Mandat conformité.'],
  ['Équipements de Levage Girard inc.', '4 206 $', '1.3%', 'Loi 25', 'Mandat conformité.'],
  ['Héritage S.E.C.', '4 206 $', '1.3%', 'Loi 25', 'Mandat conformité.'],
  ['Mory inc.', '4 206 $', '1.3%', 'Loi 25', 'Mandat conformité.'],
  ['CTAC', '4 200 $', '1.3%', 'Loi 25', 'Mandat conformité.'],
  ['Agence de communications Unik Inc.', '4 146 $', '1.3%', 'Loi 25', 'Mandat conformité.'],
  ['PCA Services corporatifs inc.', '4 146 $', '1.3%', 'Loi 25', 'Mandat conformité.'],
  ['SOCAM', '4 000 $', '1.3%', 'Non précisé', 'Contrat à clarifier.'],
  ['Gestion Immobilière Lafrance et Mathieu', '3 045 $', '1.0%', 'SAT', 'Mandat SAT.'],
  ['Externat St-Jean-Berchmans', '2 333 $', '0.7%', 'À la carte', 'Revenu ponctuel.'],
  ['Tibo', '2 250 $', '0.7%', 'Cyber 1 an', 'Client stratégique à fort potentiel futur.'],
  ['Ambioner', '2 030 $', '0.6%', 'Cyber 1 an', 'Client à repositionner en accompagnement stratégique.'],
  ['Campus Lean', '2 000 $', '0.6%', 'À la carte', 'Revenu ponctuel.'],
  ['Groupe Bernard Gagnon', '2 000 $', '0.6%', 'À la carte', 'Revenu ponctuel.'],
  ['Diesel Expert Québec inc.', '1 925 $', '0.6%', 'SAT', 'Mandat SAT.'],
  ['Barreau de Québec', '1 890 $', '0.6%', 'SAT', 'Mandat SAT.'],
  ['St-Amant et Vien Avocats', '1 838 $', '0.6%', 'À la carte', 'Revenu ponctuel.'],
  ['Aviseo Conseil', '1 785 $', '0.6%', 'SAT', 'Mandat SAT.'],
  ['EGL Construction', '1 715 $', '0.5%', 'SAT', 'Mandat SAT.'],
  ['Alliance Solutions Logistiques inc.', '1 715 $', '0.5%', 'SAT', 'Mandat SAT.'],
  ['Radio Communautaire Huronne Wyandot', '1 708 $', '0.5%', 'Non précisé', 'Contrat à clarifier.'],
  ['Sébastien Lapointe, CPA inc.', '1 610 $', '0.5%', 'SAT', 'Mandat SAT.'],
  ['Chabot Carrosserie inc.', '1 600 $', '0.5%', 'SAT', 'Mandat SAT.'],
  ["L'Intendant", '800 $', '0.3%', 'À la carte', 'Revenu ponctuel.'],
  ['Gestion de Patrimoine Normen Bouchard inc.', '755 $', '0.2%', 'SAT', 'Mandat SAT.'],
  ['COEFICIA', '750 $', '0.2%', 'À la carte', 'Revenu ponctuel.'],
  ['P.E. Pageau', '750 $', '0.2%', 'À la carte', 'Revenu ponctuel.'],
  ['K2D Assurances', '700 $', '0.2%', 'SAT', 'Mandat SAT.'],
  ['Piercon Ltée', '650 $', '0.2%', 'SAT', 'Mandat SAT.'],
  ["Groupe Céramique l'Entrepôt inc.", '645 $', '0.2%', 'SAT', 'Mandat SAT.'],
  ['Association de la Construction du Québec', '425 $', '0.1%', 'SAT', 'Mandat SAT.'],
  ['Nouveau JD', '350 $', '0.1%', 'SAT', 'Mandat SAT.'],
  ['Nova Construction C.P. inc', '350 $', '0.1%', 'SAT', 'Mandat SAT.'],
  ['Laforest Avocats', '150 $', '0.0%', 'À la carte', 'Revenu ponctuel.'],
  ['Groupe Perspective inc', '18 $', '0.0%', 'À la carte', 'Revenu ponctuel.'],
  ['Institut de gouvernance numérique', '0 $', '0.0%', 'SAT', 'Aucun revenu reconnu actuellement.'],
] as const;

const produitsRendement = [
  [
    'Holistique 3 ans',
    '182 180 $',
    '57%',
    'Produit principal du portefeuille, représentant la base la plus solide et récurrente des revenus.',
    'bg-cyan-500/10 text-cyan-300 border-cyan-500/20',
  ],
  [
    'Loi 25',
    '62 435 $',
    '20%',
    'Offre de conformité très performante, pouvant servir de porte d’entrée vers des mandats cyber ou gouvernance.',
    'bg-orange-500/10 text-orange-300 border-orange-500/20',
  ],
  [
    'À la carte',
    '43 837 $',
    '14%',
    'Revenus ponctuels intéressants, mais moins prévisibles; certains clients pourraient être convertis en accompagnement structuré.',
    'bg-yellow-500/10 text-yellow-300 border-yellow-500/20',
  ],
  [
    'SAT',
    '19 160 $',
    '6%',
    'Produit d’entrée pertinent pour détecter des opportunités de cybersécurité ou de plan directeur TI.',
    'bg-emerald-500/10 text-emerald-300 border-emerald-500/20',
  ],
  [
    'Cyber 1 an',
    '9 320 $',
    '3%',
    'Offre annuelle à développer ou repositionner pour améliorer la récurrence et les renouvellements.',
    'bg-blue-500/10 text-blue-300 border-blue-500/20',
  ],
] as const;

const clientsActifs = [
  ['Ambioner', 'FM, MDB', 'PRISME', 'Repris responsabilité du client en avril à titre de directeur TI. Comité TI établi malgré une réticence initiale du client; importance de la gouvernance démontrée.', 'Haute'],
  ['Archer', 'FM, VB, MG', 'PRISME', 'Nouveau client depuis décembre. Comité TI établi en avril. Parc vieillissant, migration cloud et évaluation à proposer.', 'Haute'],
  ['Beauvais Truchon', 'Comité IA = Dany / FM à définir / Mathieu', '', 'Relation rétablie. Tentative d’établir un comité TI. Mathieu Gallant est le prime et souhaite une rencontre mensuelle. Dany anime un comité IA avec eux.', 'Moyenne'],
  ['Conception RP', 'FM, Sébastien', '', 'Comité TI en place. Client racheté à l’interne par le DG et le directeur des opérations. Dernière rencontre en avril.', 'Moyenne'],
  ['Coop 2 Rives', 'FM, Vincent', 'PRISME', 'Dernier comité en début mai. Présentation à compléter / structurer selon la suite du mandat.', 'Haute'],
  ['Édifice 500 Grande-Allée Est inc. et 4 bourgeois / Delta / Boul Laurier / La Cité Verte', 'FM, Maxime', '', 'Client avec 15 bâtisses. Rencontre effectuée en mars. Contrat à redéfinir avec Antoine.', 'Haute'],
  ['Eximm-Complexe de Ville inc.', 'FM, Sébastien', '', 'Client avec 5 bâtisses, cloud BZ. Discussion en avril. Voyage aux États-Unis avec le président.', 'Moyenne'],
  ['Gestion Légalis inc.', 'FM, JMC, Maxime', 'PRISME', 'Comité de projets mensuel. Difficulté à obtenir un comité TI avec la direction. Bonne relation avec Nancy et Michel. Travail en équipe avec Jean-Michel et Maxime.', 'Haute'],
  ['GM Développement inc.', 'FM, Sébastien', '', 'Nouveau client cloud BZ depuis 1 an. Objectif d’établir un comité TI, aligner le rôle de directeur TI et structurer le contrat cybersécurité.', 'Haute'],
  ['Groupe MACH', 'FM, Maxime', '', 'Client avec 5 bâtisses.', 'Moyenne'],
  ['JL Leclerc', 'FM, Maxime', 'PRISME', 'Rencontre récente avec Antoine et Michael. Changement de DDC. Rôle de directeur TI assumé par FM, Maxime comme prime. Client souhaite un développement progressif projet par projet, IA et amélioration de processus.', 'Haute'],
  ['MG2', 'FM, Mathieu', '', 'Première rencontre en avril. Client peu connu par FM. Mathieu G. est bien établi. Relation à bâtir pour FM.', 'Moyenne'],
  ['Nyx Hemera Technologies inc.', 'FM, Maxime', '', 'Rencontres avec PL en avril et mai. Création d’un nouveau comité TI. Relation à développer comme directeur TI. Reprendre la responsabilité PRISME, car situation critique avec Maxime.', 'Haute'],
  ['P.E. Pageau', 'FM, Youssouf', '', 'Rencontre avec Mélissa et Youssouf en avril. Migration cloud BZ.', 'Moyenne'],
  ['PCA Services corporatifs inc.', 'FM, Maxime', '', 'En attente de la fin des impôts 2026. Communication à faire en mai. Dernière rencontre en janvier 2026.', 'Moyenne'],
  ['Poudrier Bradet Avocats', 'FM, SAC', '', 'Client difficile à rejoindre. Objectif de développer une meilleure relation.', 'Moyenne'],
  ['Steinlex inc.', 'FM, VB, Alexandre', '', 'Rencontres projets mensuelles avec Bobby et Alexandra aux 3 mois. Beaucoup de validations ponctuelles. Alexandra tente de ramener certains éléments à l’interne. Discussion souhaitée avec EH et JMC pour ramener le client dans PRISME et démontrer la valeur ajoutée.', 'Haute'],
  ['Tassé Bertrand Barabé Avocats inc.', 'FM, Maxime', 'PRISME', 'Excellente communication. Comité TI interne. Deux acquisitions. Client souhaite changer son logiciel interne JurisConcept.', 'Haute'],
  ['TB4 Ronam inc.', 'FM, Maxime', 'PRISME', 'Dernière rencontre en avril. Présentation de l’évaluation des risques avec PL et MDB. Nouveau technicien interne depuis août. Nouveau directeur d’innovation engagé. Client n’a pas renouvelé le contrat cyber; solution à trouver pour renouveler le contrat TI d’ici décembre. Relation avec le nouveau tech difficile.', 'Critique'],
  ['TIBO', 'FM, Guillaume M', '', 'Client à l’heure. Sensibilisation à faire sur l’importance d’un contrat de service. Rôle de directeur TI limité tant que le client reste en prise en charge. Possibilités futures à évaluer.', 'Haute'],
] as const;

const directionItems = [
  'Rencontre de direction BZ (1x à chaque fin de mois)',
  'Rencontre du département aux 2 semaines',
  'RH SA et Cyber',
  'Paye SA et Cyber (3)',
  'Gestion / réalisations des contrats cyber',
  'Renouvellement des contrats cyber holistiques ou cyber en général',
  'Rencontre de projets Cyber',
  'Supervision de projets SA/TI',
] as const;

const produitsComiteItems = [
  'Rencontre de produits',
  'Validation des tests',
  'Validation avec FD pour le comité de sécurité',
  'Rencontre nouveaux partenaires (Pen Test & SOC)',
] as const;

const gestionProjetsItems = [
  'Gestion de projets SA ou TI selon la demande du chargé de projets',
  'Rencontre mensuelle de projets',
  'Suivis de projets',
  'Gestion simultanée de 5 à 10 projets (actuellement 5)',
] as const;

const prismeItems = [
  'Gestion de comité TI',
  'Organisation des nouvelles rencontres PRISME (5x2h avec les clients)',
  'Objectif de 25 clients PRISME',
  'Développement des PRISME sous ma charge',
  'Développer le PRISME des employés Cyber (à faire)',
] as const;

const autresPrimeItems = [
  {
    title: 'Les développements Cromwell',
    desc: 'Agir comme directeur TI et gestionnaire de projets.',
  },
  {
    title: 'Les développements Eximm',
    desc: 'Agir comme directeur TI et gestionnaire de projets.',
  },
  {
    title: 'Groupe MACH',
    desc: 'Suivi client et accompagnement stratégique.',
  },
] as const;

const structureDepartement = [
  {
    title: 'Direction stratégique',
    items: ['Vision départementale', 'Gouvernance', 'Alignement exécutif', 'Innovation', 'Architecture PRIsME'],
    accent: 'cyan',
  },
  {
    title: 'Gouvernance & Livraison',
    items: ['Qualité livrables', 'Comité TI', 'Standardisation', 'Gestion projets', 'KPI', 'Cadence clients'],
    accent: 'violet',
  },
  {
    title: 'PRIsME & Innovation',
    items: ['UX/UI', 'Dashboards', 'Automatisation', 'IA', 'Industrialisation', 'Workflows'],
    accent: 'emerald',
  },
  {
    title: 'Cybersécurité & Conformité',
    items: ['NIST CSF', 'Loi 25', 'Risques', 'Plans cyber', 'Continuité', 'Gouvernance sécurité'],
    accent: 'orange',
  },
] as const;

const initiativesStrategiques = [
  {
    title: 'PRIsME Enterprise',
    status: 'En développement',
    priority: 'Critique',
    objective: 'Transformer PRIsME en plateforme centrale de gouvernance et pilotage client.',
  },
  {
    title: 'Standardisation des livrables',
    status: 'En cours',
    priority: 'Haute',
    objective: 'Uniformiser les rapports, plans directeurs, audits et dashboards.',
  },
  {
    title: 'Gouvernance TI Client',
    status: 'En déploiement',
    priority: 'Haute',
    objective: 'Déployer une approche standardisée des comités TI et de la gouvernance exécutive.',
  },
  {
    title: 'IA & Automatisation',
    status: 'Recherche & développement',
    priority: 'Moyenne',
    objective: 'Créer des agents IA et automatisations soutenant les opérations et la gouvernance.',
  },
] as const;

const backlogStrategique = {
  critique: ['Architecture PRIsME', 'Standardisation documentaire', 'Gouvernance départementale', 'Dashboard exécutif'],
  haute: ['Framework livraison client', 'KPI département', 'Structure RH', 'Processus qualité'],
  moyenne: ['Automatisation IA', 'Intégration analytics', 'Optimisation UX'],
} as const;

const dependancesCritiques = ['Développement PRIsME', 'Alignement direction', 'Collaboration ventes', 'Disponibilité experts', 'Documentation'] as const;
const risquesDepartement = ['Dépendance aux individus', 'Manque de standardisation', 'Charge opérationnelle élevée', 'Difficulté de scalabilité', 'Multiplication des approches clients'] as const;

const kpisExecutifs = [
  'Nombre de clients sous gouvernance',
  'Nombre de plans directeurs actifs',
  'Nombre de comités TI actifs',
  'Maturité moyenne PRIsME',
  'Revenus SA/Cyber',
  'Taux standardisation livrables',
  'Satisfaction client',
  'Nombre d’automatisations déployées',
] as const;

const priorites90Jours = [
  {
    horizon: '30 jours',
    items: ['Finaliser structure SA', 'Définir standards', 'Revoir gouvernance interne'],
    accent: 'cyan',
  },
  {
    horizon: '60 jours',
    items: ['Déployer dashboards', 'Standardiser livrables', 'Structurer KPI'],
    accent: 'violet',
  },
  {
    horizon: '90 jours',
    items: ['Déployer nouvelles cards PRIsME', 'Industrialiser workflows', 'Début automatisation IA'],
    accent: 'emerald',
  },
] as const;

export default function RencontreSACyberModal({ isOpen, onClose }: RencontreSACyberModalProps) {
  const [activeTab, setActiveTab] = useState<TabId>('revenus-6mois');

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-slate-950 z-50"
        onClick={onClose}
      />

      <motion.div
        initial={{ opacity: 0, scale: 0.96, y: 16 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.96, y: 16 }}
        className="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-slate-950 text-slate-100 border border-slate-700 shadow-2xl rounded-2xl w-[92vw] h-[92vh] flex flex-col overflow-hidden">
          <div className="border-b border-slate-800 px-6 py-5 bg-slate-950">
            <div className="flex items-start justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-2xl bg-white text-slate-950 flex items-center justify-center shadow-lg">
                  <Handshake className="w-6 h-6" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-white">Rencontre SA/Cyber</h2>
                  <p className="text-sm text-slate-300">
                    Espace de suivi exécutif pour aligner la performance financière, les écarts Cortex et les constats stratégiques SA/Cyber.
                  </p>
                </div>
              </div>

              <button
                type="button"
                onClick={onClose}
                className="inline-flex items-center justify-center rounded-full border border-slate-700 bg-slate-900 p-2 text-slate-200 hover:bg-slate-800 transition"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>

          <div className="px-6 pt-4 pb-3 border-b border-slate-800 bg-slate-950">
            <div className="flex flex-wrap gap-2">
              <button
                type="button"
                onClick={() => setActiveTab('revenus-6mois')}
                className={`px-4 py-2 rounded-xl text-sm font-semibold transition ${
                  activeTab === 'revenus-6mois'
                    ? 'bg-white text-slate-950'
                    : 'bg-slate-900 text-slate-300 border border-slate-700'
                }`}
              >
                Revenus des 6 derniers mois
              </button>
              <button
                type="button"
                onClick={() => setActiveTab('clients-rendement')}
                className={`px-4 py-2 rounded-xl text-sm font-semibold transition ${
                  activeTab === 'clients-rendement'
                    ? 'bg-white text-slate-950'
                    : 'bg-slate-900 text-slate-300 border border-slate-700'
                }`}
              >
                Clients par rendement
              </button>
              <button
                type="button"
                onClick={() => setActiveTab('produits')}
                className={`px-4 py-2 rounded-xl text-sm font-semibold transition ${
                  activeTab === 'produits'
                    ? 'bg-white text-slate-950'
                    : 'bg-slate-900 text-slate-300 border border-slate-700'
                }`}
              >
                Produits par rendement
              </button>
              <button
                type="button"
                onClick={() => setActiveTab('clients-actifs')}
                className={`px-4 py-2 rounded-xl text-sm font-semibold transition ${
                  activeTab === 'clients-actifs'
                    ? 'bg-white text-slate-950'
                    : 'bg-slate-900 text-slate-300 border border-slate-700'
                }`}
              >
                Clients actifs
              </button>
              <button
                type="button"
                onClick={() => setActiveTab('roles-responsabilites')}
                className={`px-4 py-2 rounded-xl text-sm font-semibold transition ${
                  activeTab === 'roles-responsabilites'
                    ? 'bg-white text-slate-950'
                    : 'bg-slate-900 text-slate-300 border border-slate-700'
                }`}
              >
                Rôles & responsabilités
              </button>
              <button
                type="button"
                onClick={() => setActiveTab('gouvernance-sa-cyber')}
                className={`px-4 py-2 rounded-xl text-sm font-semibold transition ${
                  activeTab === 'gouvernance-sa-cyber'
                    ? 'bg-white text-slate-950'
                    : 'bg-slate-900 text-slate-300 border border-slate-700'
                }`}
              >
                Gouvernance SA/Cyber
              </button>
            </div>
          </div>

          <div className="flex-1 overflow-y-auto px-6 py-6 bg-slate-950 space-y-6">
            {activeTab === 'revenus-6mois' && (
              <>
                <section className="rounded-2xl border border-cyan-500/20 bg-[#0b1120] p-6 shadow-2xl">
                  <div className="flex items-center justify-between flex-wrap gap-4">
                    <div>
                      <h3 className="text-3xl font-bold text-white tracking-tight">
                        Performance financière — Revenus SA/Cyber
                      </h3>
                      <p className="text-slate-400 mt-2 max-w-3xl">
                        Vue exécutive des revenus générés par le département Solutions d’affaires & Cybersécurité au cours des 6 derniers mois, incluant l’analyse des écarts entre Cortex et les ventes réelles clients.
                      </p>
                    </div>

                    <div className="px-4 py-2 rounded-xl border border-orange-400/30 bg-orange-500/10">
                      <div className="text-orange-300 text-sm font-medium">État</div>
                      <div className="text-white font-bold text-lg">Ajustement Cortex requis</div>
                    </div>
                  </div>
                </section>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
                  <KpiCard title="Revenus Cortex (6 mois)" value="262 111 $" subtitle="Revenus actuellement consolidés dans Cortex" accent="cyan" icon={<DollarSign className="w-5 h-5" />} />
                  <KpiCard title="Ventes Clients Totales" value="316 930 $" subtitle="Valeur totale vendue aux clients" accent="emerald" icon={<TrendingUp className="w-5 h-5" />} />
                  <KpiCard title="Écart Financier" value="54 819 $" subtitle="Différence entre Cortex et les ventes réelles" accent="yellow" icon={<AlertTriangle className="w-5 h-5" />} />
                  <KpiCard title="Moyenne Mensuelle" value="43 685 $" subtitle="Revenus moyens mensuels SA/Cyber" accent="violet" icon={<BarChart3 className="w-5 h-5" />} />
                </div>

                <section className="rounded-2xl border border-slate-700 bg-[#0f172a] overflow-hidden shadow-2xl">
                  <div className="px-6 py-5 border-b border-slate-700">
                    <h3 className="text-xl font-bold text-white">Revenus des 6 derniers mois</h3>
                    <p className="text-slate-400 text-sm mt-1">
                      Évolution mensuelle des revenus Solutions d’affaires & Cybersécurité
                    </p>
                  </div>

                  <div className="overflow-auto">
                    <table className="w-full">
                      <thead className="bg-[#111827]">
                        <tr>
                          <th className="text-left px-6 py-4 text-slate-300 font-semibold">Mois</th>
                          <th className="text-right px-6 py-4 text-slate-300 font-semibold">Revenus</th>
                        </tr>
                      </thead>
                      <tbody>
                        {revenusMensuels.map((item) => (
                          <tr key={item.mois} className="border-t border-slate-800 hover:bg-white/5">
                            <td className="px-6 py-4 text-white">{item.mois}</td>
                            <td className="px-6 py-4 text-right text-cyan-300 font-semibold">{item.revenus}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </section>

                <div className="grid grid-cols-1 xl:grid-cols-2 gap-5">
                  <section className="rounded-2xl border border-slate-700 bg-[#0f172a] p-6 shadow-2xl">
                    <h3 className="text-xl font-bold text-white mb-5">Analyse financière</h3>

                    <div className="space-y-5">
                      <div className="rounded-xl bg-[#111827] border border-slate-700 p-4">
                        <div className="text-slate-400 text-sm mb-2">Différence observée</div>
                        <div className="text-2xl font-black text-yellow-300">54 819 $</div>
                        <div className="text-sm text-slate-500 mt-2">
                          Écart entre les revenus Cortex et les ventes clients réelles.
                        </div>
                      </div>

                      <div>
                        <h4 className="text-white font-semibold mb-3">Explication probable de l’écart</h4>
                        <ul className="space-y-2 text-slate-300 text-sm">
                          <li>• Produits à la carte</li>
                          <li>• Revenus cybersécurité sur 1 an</li>
                          <li>• Projets ponctuels</li>
                          <li>• Revenus non encore consolidés dans Cortex</li>
                          <li>• Décalage entre ventes, facturation et reconnaissance des revenus</li>
                        </ul>
                      </div>
                    </div>
                  </section>

                  <section className="rounded-2xl border border-slate-700 bg-[#0f172a] p-6 shadow-2xl">
                    <h3 className="text-xl font-bold text-white mb-5">Constats exécutifs</h3>

                    <div className="space-y-4">
                      <InsightCard
                        title="Revenus stables"
                        body="Le département maintient une stabilité financière saine avec une moyenne mensuelle constante autour de 43 685 $."
                        tone="emerald"
                      />
                      <InsightCard
                        title="Bonne constance opérationnelle"
                        body="Peu de variation entre les mois, démontrant une bonne rétention client, une stabilité des revenus récurrents et une croissance maîtrisée."
                        tone="cyan"
                      />
                      <InsightCard
                        title="Ajustement Cortex requis"
                        body="Un alignement financier est recommandé afin de mieux distinguer les revenus récurrents, les projets ponctuels et les contrats cybersécurité annuels."
                        tone="orange"
                      />
                    </div>
                  </section>
                </div>
              </>
            )}

            {activeTab === 'clients-rendement' && (
              <>
                <section className="rounded-2xl border border-cyan-500/20 bg-[#0b1120] p-6 shadow-2xl">
                  <div className="flex items-center justify-between flex-wrap gap-4">
                    <div>
                      <h3 className="text-3xl font-bold text-white tracking-tight">
                        Liste des clients — Rendement financier
                      </h3>
                      <p className="text-slate-400 mt-2 max-w-4xl">
                        Classement décroissant des clients selon les revenus générés. Cette vue permet d’identifier rapidement les comptes stratégiques, les revenus récurrents, les revenus ponctuels et les contrats nécessitant un suivi de gouvernance ou un ajustement Cortex.
                      </p>
                    </div>

                    <div className="px-4 py-2 rounded-xl border border-emerald-400/30 bg-emerald-500/10">
                      <div className="text-emerald-300 text-sm font-medium">Total ventes clients</div>
                      <div className="text-white font-bold text-lg">316 932 $</div>
                    </div>
                  </div>
                </section>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
                  <section className="rounded-2xl bg-[#111827] border border-cyan-500/20 p-5 shadow-xl">
                    <div className="text-slate-400 text-sm mb-2">Client #1</div>
                    <div className="text-2xl font-black text-cyan-400">Atlantis Pompe</div>
                    <div className="mt-3 text-xl font-bold text-white">34 608 $</div>
                    <div className="text-sm text-slate-500">10.9 % du total</div>
                  </section>
                  <section className="rounded-2xl bg-[#111827] border border-emerald-500/20 p-5 shadow-xl">
                    <div className="text-slate-400 text-sm mb-2">Top 5 clients</div>
                    <div className="text-4xl font-black text-emerald-400">117 722 $</div>
                    <div className="mt-3 text-sm text-slate-500">Atlantis, Flyscan, Légalis, Château Laurier, DFM</div>
                  </section>
                  <section className="rounded-2xl bg-[#111827] border border-violet-500/20 p-5 shadow-xl">
                    <div className="text-slate-400 text-sm mb-2">Top 10 clients</div>
                    <div className="text-4xl font-black text-violet-300">172 636 $</div>
                    <div className="mt-3 text-sm text-slate-500">Environ 54.5 % des revenus clients</div>
                  </section>
                  <section className="rounded-2xl bg-[#111827] border border-orange-500/20 p-5 shadow-xl">
                    <div className="text-slate-400 text-sm mb-2">Lecture exécutive</div>
                    <div className="text-xl font-black text-orange-300">Forte concentration</div>
                    <div className="mt-3 text-sm text-slate-500">Les premiers clients représentent une part importante du rendement.</div>
                  </section>
                </div>

                <section className="rounded-2xl border border-yellow-500/20 bg-yellow-500/10 p-5">
                  <h3 className="text-yellow-300 font-bold text-lg mb-2">Dernières communications</h3>
                  <p className="text-slate-300 text-sm">
                    Les dernières communications pourront être ajoutées dans la colonne prévue à cet effet lorsque les notes clients ou suivis CRM seront disponibles. Pour la présentation actuelle, la priorité est mise sur le rendement financier, le type de contrat et la lecture stratégique.
                  </p>
                </section>

                <section className="rounded-2xl border border-slate-700 bg-[#0f172a] overflow-hidden shadow-2xl">
                  <div className="px-6 py-5 border-b border-slate-700">
                    <h3 className="text-xl font-bold text-white">Classement des clients par revenu décroissant</h3>
                    <p className="text-slate-400 text-sm mt-1">Revenus SA/Cyber consolidés par client — total : 316 932 $</p>
                  </div>

                  <div className="overflow-auto max-h-[720px]">
                    <table className="w-full text-sm">
                      <thead className="bg-[#111827] sticky top-0 z-10">
                        <tr>
                          <th className="text-left px-5 py-4 text-slate-300 font-semibold">Client</th>
                          <th className="text-right px-5 py-4 text-slate-300 font-semibold">Revenu</th>
                          <th className="text-right px-5 py-4 text-slate-300 font-semibold">% total</th>
                          <th className="text-left px-5 py-4 text-slate-300 font-semibold">Contrat</th>
                          <th className="text-left px-5 py-4 text-slate-300 font-semibold">Lecture stratégique</th>
                        </tr>
                      </thead>
                      <tbody>
                        {clientsRendement.map((client, index) => (
                          <tr key={index} className="border-t border-slate-800 hover:bg-white/5 transition-colors">
                            <td className="px-5 py-3 text-white font-medium max-w-[360px]">{client[0]}</td>
                            <td className="px-5 py-3 text-right text-emerald-300 font-bold whitespace-nowrap">{client[1]}</td>
                            <td className="px-5 py-3 text-right text-cyan-300 whitespace-nowrap">{client[2]}</td>
                            <td className="px-5 py-3">
                              <span className={`px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${getContractBadgeClass(client[3])}`}>
                                {client[3]}
                              </span>
                            </td>
                            <td className="px-5 py-3 text-slate-400">{client[4]}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </section>

                <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
                  <InsightCard
                    title="Clients stratégiques"
                    body="Les clients holistiques 3 ans représentent la base la plus solide du portefeuille. Ils doivent être suivis dans une cadence de gouvernance claire afin de maintenir la valeur et favoriser les renouvellements."
                    tone="cyan"
                  />
                  <InsightCard
                    title="Revenus ponctuels"
                    body="Les clients à la carte génèrent des revenus importants, mais moins prévisibles. Certains devraient être ciblés pour une conversion vers un accompagnement annuel ou une offre structurée."
                    tone="yellow"
                  />
                  <InsightCard
                    title="Opportunité de croissance"
                    body="Les mandats Loi 25, SAT et Cyber 1 an peuvent devenir des portes d’entrée vers des accompagnements plus complets en gouvernance, cybersécurité et plan directeur TI."
                    tone="emerald"
                  />
                </div>
              </>
            )}

            {activeTab === 'produits' && (
              <>
                <section className="rounded-2xl border border-cyan-500/20 bg-[#0b1120] p-6 shadow-2xl">
                  <div className="flex items-center justify-between flex-wrap gap-4">
                    <div>
                      <h3 className="text-3xl font-bold text-white tracking-tight">
                        Produits — Classement par rendement financier
                      </h3>
                      <p className="text-slate-400 mt-2 max-w-4xl">
                        Vue consolidée des revenus par type de produit SA/Cyber. Cette lecture permet d’identifier les offres les plus rentables, les revenus récurrents dominants et les opportunités de conversion vers des offres structurées.
                      </p>
                    </div>

                    <div className="px-4 py-2 rounded-xl border border-emerald-400/30 bg-emerald-500/10">
                      <div className="text-emerald-300 text-sm font-medium">Total produits</div>
                      <div className="text-white font-bold text-lg">316 932 $</div>
                    </div>
                  </div>
                </section>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
                  <section className="rounded-2xl bg-[#111827] border border-cyan-500/20 p-5 shadow-xl">
                    <div className="text-slate-400 text-sm mb-2">Produit dominant</div>
                    <div className="text-2xl font-black text-cyan-400">Holistique 3 ans</div>
                    <div className="mt-3 text-xl font-bold text-white">182 180 $</div>
                    <div className="text-sm text-slate-500">57 % du total</div>
                  </section>

                  <section className="rounded-2xl bg-[#111827] border border-orange-500/20 p-5 shadow-xl">
                    <div className="text-slate-400 text-sm mb-2">Conformité</div>
                    <div className="text-2xl font-black text-orange-300">Loi 25</div>
                    <div className="mt-3 text-xl font-bold text-white">62 435 $</div>
                    <div className="text-sm text-slate-500">20 % du total</div>
                  </section>

                  <section className="rounded-2xl bg-[#111827] border border-yellow-500/20 p-5 shadow-xl">
                    <div className="text-slate-400 text-sm mb-2">Revenus ponctuels</div>
                    <div className="text-2xl font-black text-yellow-300">À la carte</div>
                    <div className="mt-3 text-xl font-bold text-white">43 837 $</div>
                    <div className="text-sm text-slate-500">14 % du total</div>
                  </section>

                  <section className="rounded-2xl bg-[#111827] border border-emerald-500/20 p-5 shadow-xl">
                    <div className="text-slate-400 text-sm mb-2">Revenus structurés</div>
                    <div className="text-4xl font-black text-emerald-400">77 %</div>
                    <div className="mt-3 text-sm text-slate-500">Holistique 3 ans + Loi 25</div>
                  </section>
                </div>

                <section className="rounded-2xl border border-slate-700 bg-[#0f172a] overflow-hidden shadow-2xl">
                  <div className="px-6 py-5 border-b border-slate-700">
                    <h3 className="text-xl font-bold text-white">Répartition des revenus par produit</h3>
                    <p className="text-slate-400 text-sm mt-1">Produits classés par ordre décroissant de rendement financier.</p>
                  </div>

                  <div className="overflow-auto">
                    <table className="w-full text-sm">
                      <thead className="bg-[#111827]">
                        <tr>
                          <th className="text-left px-5 py-4 text-slate-300 font-semibold">Produit</th>
                          <th className="text-right px-5 py-4 text-slate-300 font-semibold">Revenu</th>
                          <th className="text-right px-5 py-4 text-slate-300 font-semibold">% du total</th>
                          <th className="text-left px-5 py-4 text-slate-300 font-semibold">Lecture stratégique</th>
                        </tr>
                      </thead>
                      <tbody>
                        {produitsRendement.map((produit, index) => (
                          <tr key={index} className="border-t border-slate-800 hover:bg-white/5 transition-colors">
                            <td className="px-5 py-4">
                              <span className={`px-3 py-1 rounded-full text-xs font-semibold border ${produit[4]}`}>
                                {produit[0]}
                              </span>
                            </td>
                            <td className="px-5 py-4 text-right text-emerald-300 font-bold whitespace-nowrap">{produit[1]}</td>
                            <td className="px-5 py-4 text-right text-cyan-300 font-bold whitespace-nowrap">{produit[2]}</td>
                            <td className="px-5 py-4 text-slate-400">{produit[3]}</td>
                          </tr>
                        ))}

                        <tr className="border-t border-slate-700 bg-[#111827]">
                          <td className="px-5 py-4 text-white font-black">Total</td>
                          <td className="px-5 py-4 text-right text-emerald-300 font-black">316 932 $</td>
                          <td className="px-5 py-4 text-right text-cyan-300 font-black">100%</td>
                          <td className="px-5 py-4 text-slate-400">Total consolidé des revenus produits SA/Cyber.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>

                <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
                  <InsightCard
                    title="Offre dominante"
                    body="L’offre Holistique 3 ans représente 57 % des revenus, ce qui confirme que les accompagnements structurés sont le cœur financier du portefeuille."
                    tone="cyan"
                  />
                  <InsightCard
                    title="Conformité rentable"
                    body="La Loi 25 représente 20 % des revenus. Elle constitue une excellente porte d’entrée pour développer des mandats de cybersécurité, gouvernance et gestion des risques."
                    tone="orange"
                  />
                  <InsightCard
                    title="Revenus à convertir"
                    body="Les revenus à la carte représentent 14 %. Une partie de ces revenus pourrait être transformée en offres annuelles ou en accompagnements plus prévisibles."
                    tone="yellow"
                  />
                </div>
              </>
            )}

            {activeTab === 'clients-actifs' && (
              <>
                <section className="rounded-2xl border border-cyan-500/20 bg-[#0b1120] p-6 shadow-2xl">
                  <div className="flex items-center justify-between flex-wrap gap-4">
                    <div>
                      <h3 className="text-3xl font-bold text-white tracking-tight">
                        Clients actifs sous responsabilité
                      </h3>
                      <p className="text-slate-400 mt-2 max-w-4xl">
                        Vue de gestion des clients actifs sous ma responsabilité, incluant les comités TI, projets en cours, implication PRISME, état relationnel et prochaines actions de gouvernance.
                      </p>
                    </div>

                    <div className="px-4 py-2 rounded-xl border border-emerald-400/30 bg-emerald-500/10">
                      <div className="text-emerald-300 text-sm font-medium">Portefeuille actif</div>
                      <div className="text-white font-bold text-lg">20 clients</div>
                    </div>
                  </div>
                </section>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
                  <section className="rounded-2xl bg-[#111827] border border-cyan-500/20 p-5 shadow-xl">
                    <div className="text-slate-400 text-sm mb-2">Clients suivis</div>
                    <div className="text-4xl font-black text-cyan-400">20</div>
                    <div className="mt-3 text-sm text-slate-500">Clients actifs sous responsabilité directe ou partagée.</div>
                  </section>

                  <section className="rounded-2xl bg-[#111827] border border-violet-500/20 p-5 shadow-xl">
                    <div className="text-slate-400 text-sm mb-2">Clients PRISME</div>
                    <div className="text-4xl font-black text-violet-300">7</div>
                    <div className="mt-3 text-sm text-slate-500">Ambioner, Archer, Coop 2 Rives, Légalis, JL Leclerc, TBB, TB4.</div>
                  </section>

                  <section className="rounded-2xl bg-[#111827] border border-orange-500/20 p-5 shadow-xl">
                    <div className="text-slate-400 text-sm mb-2">Relations à développer</div>
                    <div className="text-4xl font-black text-orange-300">8+</div>
                    <div className="mt-3 text-sm text-slate-500">Clients à structurer, repositionner ou ramener dans une cadence TI.</div>
                  </section>

                  <section className="rounded-2xl bg-[#111827] border border-emerald-500/20 p-5 shadow-xl">
                    <div className="text-slate-400 text-sm mb-2">Lecture exécutive</div>
                    <div className="text-xl font-black text-emerald-400">Gouvernance active</div>
                    <div className="mt-3 text-sm text-slate-500">Plusieurs comptes nécessitent un encadrement directeur TI.</div>
                  </section>
                </div>

                <section className="rounded-2xl border border-slate-700 bg-[#0f172a] overflow-hidden shadow-2xl">
                  <div className="px-6 py-5 border-b border-slate-700">
                    <h3 className="text-xl font-bold text-white">Suivi des clients actifs</h3>
                    <p className="text-slate-400 text-sm mt-1">Clients sous responsabilité, intervenants, statut PRISME et état de situation.</p>
                  </div>

                  <div className="overflow-auto max-h-[760px]">
                    <table className="w-full text-sm">
                      <thead className="bg-[#111827] sticky top-0 z-10">
                        <tr>
                          <th className="text-left px-5 py-4 text-slate-300 font-semibold">Client</th>
                          <th className="text-left px-5 py-4 text-slate-300 font-semibold">Comité TI / Projets</th>
                          <th className="text-left px-5 py-4 text-slate-300 font-semibold">PRISME</th>
                          <th className="text-left px-5 py-4 text-slate-300 font-semibold">État de situation</th>
                          <th className="text-left px-5 py-4 text-slate-300 font-semibold">Priorité</th>
                        </tr>
                      </thead>
                      <tbody>
                        {clientsActifs.map((client, index) => (
                          <tr key={index} className="border-t border-slate-800 hover:bg-white/5 transition-colors">
                            <td className="px-5 py-4 text-white font-semibold max-w-[260px]">{client[0]}</td>
                            <td className="px-5 py-4 text-slate-300 whitespace-pre-line">{client[1]}</td>
                            <td className="px-5 py-4">
                              {client[2] === 'PRISME' ? (
                                <span className="px-3 py-1 rounded-full text-xs font-semibold bg-violet-500/10 text-violet-300 border border-violet-500/20">
                                  PRISME
                                </span>
                              ) : (
                                <span className="px-3 py-1 rounded-full text-xs font-semibold bg-slate-500/10 text-slate-400 border border-slate-500/20">
                                  À structurer
                                </span>
                              )}
                            </td>
                            <td className="px-5 py-4 text-slate-400 max-w-[640px] leading-relaxed">{client[3]}</td>
                            <td className="px-5 py-4">
                              <span className={`px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${getPriorityBadgeClass(client[4])}`}>
                                {client[4]}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </section>

                <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
                  <InsightCard
                    title="Gouvernance client"
                    body="Plusieurs clients sont maintenant suivis avec une posture de directeur TI, ce qui permet de structurer les priorités, les risques, les budgets et les décisions."
                    tone="cyan"
                  />
                  <InsightCard
                    title="PRISME à renforcer"
                    body="Les clients PRISME représentent les comptes où la valeur stratégique est la plus visible. Certains clients pourraient être ramenés dans cette approche pour mieux démontrer la valeur."
                    tone="violet"
                  />
                  <InsightCard
                    title="Priorités relationnelles"
                    body="Plusieurs comptes nécessitent un repositionnement relationnel, une cadence de comité TI ou une clarification contractuelle afin de sécuriser les revenus et les renouvellements."
                    tone="orange"
                  />
                </div>
              </>
            )}

            {activeTab === 'roles-responsabilites' && (
              <>
                <section className="rounded-2xl border border-cyan-500/20 bg-[#0b1120] p-6 shadow-2xl">
                  <div className="flex items-center justify-between flex-wrap gap-4">
                    <div>
                      <h3 className="text-3xl font-bold text-white tracking-tight">Rôles & responsabilités</h3>
                      <p className="text-slate-400 mt-2 max-w-4xl">
                        Vue globale des responsabilités actuelles en lien avec la direction du département Solutions d’affaires & Cybersécurité, la gouvernance client, les projets TI, PRISME et les responsabilités stratégiques.
                      </p>
                    </div>

                    <div className="px-4 py-2 rounded-xl border border-emerald-400/30 bg-emerald-500/10">
                      <div className="text-emerald-300 text-sm font-medium">Lecture exécutive</div>
                      <div className="text-white font-bold text-lg">Multi-rôles stratégique</div>
                    </div>
                  </div>
                </section>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
                  <section className="rounded-2xl bg-[#111827] border border-cyan-500/20 p-5 shadow-xl">
                    <div className="text-slate-400 text-sm mb-2">Rôle principal</div>
                    <div className="text-2xl font-black text-cyan-400">Direction SA/Cyber</div>
                    <div className="mt-3 text-sm text-slate-500">Gouvernance, stratégie et développement départemental.</div>
                  </section>
                  <section className="rounded-2xl bg-[#111827] border border-violet-500/20 p-5 shadow-xl">
                    <div className="text-slate-400 text-sm mb-2">Projets actifs</div>
                    <div className="text-4xl font-black text-violet-300">5</div>
                    <div className="mt-3 text-sm text-slate-500">Gestion simultanée actuelle de projets SA/TI.</div>
                  </section>
                  <section className="rounded-2xl bg-[#111827] border border-orange-500/20 p-5 shadow-xl">
                    <div className="text-slate-400 text-sm mb-2">Objectif PRISME</div>
                    <div className="text-4xl font-black text-orange-300">25</div>
                    <div className="mt-3 text-sm text-slate-500">Clients PRISME sous gouvernance active.</div>
                  </section>
                  <section className="rounded-2xl bg-[#111827] border border-emerald-500/20 p-5 shadow-xl">
                    <div className="text-slate-400 text-sm mb-2">Implication globale</div>
                    <div className="text-xl font-black text-emerald-400">Direction + Opérations</div>
                    <div className="mt-3 text-sm text-slate-500">Forte implication stratégique, tactique et opérationnelle.</div>
                  </section>
                </div>

                <div className="space-y-6">
                  <RoleSection
                    title="Direction département SA & Cyber"
                    accent="cyan"
                    items={directionItems}
                    columns="xl:grid-cols-2"
                  />

                  <RoleSection
                    title="Comité de produits"
                    accent="violet"
                    subtitle="1 rencontre par mois"
                    items={produitsComiteItems}
                    columns="xl:grid-cols-2"
                  />

                  <RoleSection
                    title="Gestion de projets TI"
                    accent="orange"
                    items={gestionProjetsItems}
                    columns="xl:grid-cols-2"
                  />

                  <RoleSection
                    title="PRIsME"
                    accent="emerald"
                    items={prismeItems}
                    columns="xl:grid-cols-2"
                  />

                  <section className="rounded-2xl border border-yellow-500/20 bg-[#0f172a] overflow-hidden shadow-2xl">
                    <div className="px-6 py-5 border-b border-yellow-500/20 bg-yellow-500/10">
                      <h3 className="text-2xl font-bold text-yellow-300">Autres responsabilités PRIME client</h3>
                    </div>
                    <div className="p-6 grid grid-cols-1 xl:grid-cols-3 gap-4">
                      {autresPrimeItems.map((item) => (
                        <div key={item.title} className="rounded-xl border border-yellow-500/10 bg-[#111827] p-5 hover:border-yellow-400 transition-all">
                          <div className="text-lg font-bold text-white mb-2">{item.title}</div>
                          <div className="text-sm text-slate-400">{item.desc}</div>
                        </div>
                      ))}
                    </div>
                  </section>
                </div>

                <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
                  <InsightCard
                    title="Gouvernance stratégique"
                    body="Le rôle dépasse largement la cybersécurité technique et inclut la gouvernance, la direction départementale, la gestion client et le développement stratégique."
                    tone="cyan"
                  />
                  <InsightCard
                    title="Forte polyvalence"
                    body="Les responsabilités couvrent simultanément les volets humains, financiers, opérationnels, techniques et relationnels."
                    tone="violet"
                  />
                  <InsightCard
                    title="Croissance PRISME"
                    body="Le développement de PRISME représente un levier stratégique important pour structurer les clients, démontrer la valeur et augmenter la maturité TI."
                    tone="orange"
                  />
                </div>
              </>
            )}

            {activeTab === 'gouvernance-sa-cyber' && (
              <>
                <section className="relative overflow-hidden rounded-3xl border border-cyan-400/20 bg-[#050b17] p-7 shadow-[0_0_40px_rgba(34,211,238,0.08)]">
                  <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(34,211,238,0.14),transparent_28%),radial-gradient(circle_at_top_right,rgba(139,92,246,0.14),transparent_32%),radial-gradient(circle_at_bottom,rgba(59,130,246,0.12),transparent_34%)]" />
                  <div className="absolute inset-0 opacity-40 bg-[linear-gradient(135deg,transparent,rgba(255,255,255,0.03),transparent)]" />
                  <div className="relative space-y-4">
                    <div className="inline-flex items-center rounded-full border border-cyan-400/20 bg-cyan-500/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.24em] text-cyan-300">
                      Solutions d’affaires & Cybersécurité • Powered by PRIsME
                    </div>
                    <h3 className="text-3xl md:text-4xl font-black text-white tracking-tight">Gouvernance du Département SA/Cyber</h3>
                    <p className="text-slate-300 max-w-4xl text-base md:text-lg">
                      Pilotage stratégique • PRIsME • Gouvernance • Innovation • Industrialisation
                    </p>
                  </div>
                </section>

                <section className="rounded-3xl border border-cyan-500/20 bg-[#08111f] p-6 shadow-[0_0_30px_rgba(34,211,238,0.06)] backdrop-blur-[2px] space-y-6">
                  <div>
                    <div className="text-cyan-300 text-sm font-semibold uppercase tracking-wide mb-2">Vision du département</div>
                    <p className="text-white text-lg font-semibold">
                      Faire évoluer BZ d’un fournisseur TI traditionnel vers un partenaire stratégique de gouvernance TI, cybersécurité et transformation numérique.
                    </p>
                  </div>
                  <div>
                    <div className="text-cyan-300 text-sm font-semibold uppercase tracking-wide mb-2">Mission</div>
                    <p className="text-slate-300">
                      Structurer une approche standardisée, industrialisée et soutenue par PRIsME afin d’offrir une gouvernance TI moderne alignée aux besoins d’affaires des clients.
                    </p>
                  </div>
                  <div>
                    <div className="text-cyan-300 text-sm font-semibold uppercase tracking-wide mb-3">Objectifs clés</div>
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                      {['Industrialiser les approches', 'Standardiser les livrables', 'Structurer la gouvernance client', 'Développer PRIsME', 'Déployer l’IA et l’automatisation', 'Augmenter la maturité des clients'].map((item) => (
                        <div key={item} className="rounded-xl border border-cyan-500/10 bg-[#111827] p-4 text-white font-medium shadow-[0_0_18px_rgba(34,211,238,0.04)] hover:border-cyan-400/30 transition-all duration-300">
                          {item}
                        </div>
                      ))}
                    </div>
                  </div>
                </section>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
                  <KpiCard title="Clients sous gouvernance" value="20" subtitle="Portefeuille actif encadré" accent="cyan" icon={<Handshake className="w-5 h-5" />} />
                  <KpiCard title="Plans directeurs actifs" value="5" subtitle="En gestion ou en évolution" accent="violet" icon={<BarChart3 className="w-5 h-5" />} />
                  <KpiCard title="Revenus SA/Cyber" value="316 932 $" subtitle="Lecture exécutive consolidée" accent="emerald" icon={<DollarSign className="w-5 h-5" />} />
                  <KpiCard title="Standardisation cible" value="77 %" subtitle="Livrables structurés à renforcer" accent="yellow" icon={<TrendingUp className="w-5 h-5" />} />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
                  {structureDepartement.map((bloc) => (
                    <section key={bloc.title} className="rounded-2xl border border-slate-700 bg-[#0b1220] overflow-hidden shadow-[0_0_24px_rgba(34,211,238,0.04)] hover:shadow-[0_0_28px_rgba(139,92,246,0.10)] transition-all duration-300">
                      <div className={`px-5 py-4 border-b ${getAccentHeaderClass(bloc.accent)}`}>
                        <h3 className="text-xl font-bold">{bloc.title}</h3>
                      </div>
                      <div className="p-5 space-y-3">
                        {bloc.items.map((item) => (
                          <div key={item} className="rounded-xl border border-slate-700 bg-[#111827] p-3 text-sm text-slate-200 hover:border-cyan-400/20 transition-all duration-300">
                            {item}
                          </div>
                        ))}
                      </div>
                    </section>
                  ))}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
                  {initiativesStrategiques.map((initiative) => (
                    <section key={initiative.title} className="rounded-2xl border border-slate-700 bg-[#0b1220] p-5 shadow-[0_0_24px_rgba(59,130,246,0.05)] hover:shadow-[0_0_32px_rgba(34,211,238,0.09)] transition-all duration-300 space-y-4">
                      <div className="flex items-start justify-between gap-3">
                        <h3 className="text-lg font-bold text-white">{initiative.title}</h3>
                        <span className={`px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${getPriorityBadgeClass(initiative.priority)}`}>
                          {initiative.priority}
                        </span>
                      </div>
                      <div className="text-sm text-slate-400">Statut : <span className="text-slate-200 font-medium">{initiative.status}</span></div>
                      <p className="text-sm text-slate-300">{initiative.objective}</p>
                    </section>
                  ))}
                </div>

                <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
                  <KanbanColumn title="Critique" accent="red" items={backlogStrategique.critique} />
                  <KanbanColumn title="Haute" accent="orange" items={backlogStrategique.haute} />
                  <KanbanColumn title="Moyenne" accent="cyan" items={backlogStrategique.moyenne} />
                </div>

                <div className="grid grid-cols-1 xl:grid-cols-2 gap-5">
                  <RoleSection title="Dépendances critiques" accent="orange" items={dependancesCritiques} columns="xl:grid-cols-1" />
                  <RoleSection title="Risques" accent="violet" items={risquesDepartement} columns="xl:grid-cols-1" />
                </div>

                <section className="rounded-2xl border border-emerald-500/20 bg-[#0b1220] overflow-hidden shadow-[0_0_30px_rgba(16,185,129,0.06)]">
                  <div className="px-6 py-5 border-b border-emerald-500/20 bg-emerald-500/10">
                    <h3 className="text-2xl font-bold text-emerald-300">KPI exécutifs</h3>
                  </div>
                  <div className="p-6 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
                    {kpisExecutifs.map((item) => (
                      <div key={item} className="rounded-xl border border-emerald-500/10 bg-[#111827] p-4 text-white font-medium hover:border-emerald-400/30 transition-all duration-300">
                        <div className="mb-3">{item}</div>
                        <div className="h-2 rounded-full bg-slate-800 overflow-hidden">
                          <div className="h-full rounded-full bg-gradient-to-r from-cyan-400 via-violet-400 to-emerald-400" style={{ width: `${68 + (item.length % 18)}%` }} />
                        </div>
                      </div>
                    ))}
                  </div>
                </section>

                <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
                  {priorites90Jours.map((bloc) => (
                    <section key={bloc.horizon} className="rounded-2xl border border-slate-700 bg-[#0b1220] overflow-hidden shadow-[0_0_22px_rgba(139,92,246,0.05)] hover:shadow-[0_0_30px_rgba(34,211,238,0.08)] transition-all duration-300">
                      <div className={`px-6 py-5 border-b ${getAccentHeaderClass(bloc.accent)}`}>
                        <h3 className="text-2xl font-bold">{bloc.horizon}</h3>
                      </div>
                      <div className="p-6 space-y-4">
                        {bloc.items.map((item, itemIndex) => (
                          <div key={item} className="flex items-start gap-4">
                            <div className="flex flex-col items-center pt-1">
                              <div className="w-3 h-3 rounded-full bg-gradient-to-br from-cyan-400 to-violet-400 shadow-[0_0_12px_rgba(34,211,238,0.45)]" />
                              {itemIndex < bloc.items.length - 1 && <div className="w-px h-10 bg-gradient-to-b from-cyan-400/60 to-transparent mt-2" />}
                            </div>
                            <div className="flex-1 rounded-xl border border-slate-700 bg-[#111827] p-4 text-slate-200 font-medium hover:border-cyan-400/20 transition-all duration-300">
                              {item}
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}

function KpiCard({
  title,
  value,
  subtitle,
  accent,
  icon,
}: {
  title: string;
  value: string;
  subtitle: string;
  accent: 'cyan' | 'emerald' | 'yellow' | 'violet';
  icon: React.ReactNode;
}) {
  const accentClasses = {
    cyan: 'border-cyan-500/20 hover:border-cyan-400 text-cyan-400',
    emerald: 'border-emerald-500/20 hover:border-emerald-400 text-emerald-400',
    yellow: 'border-yellow-500/20 hover:border-yellow-400 text-yellow-300',
    violet: 'border-violet-500/20 hover:border-violet-400 text-violet-300',
  } as const;

  return (
    <section className={`rounded-2xl bg-[#111827] border p-5 shadow-xl transition-all duration-300 ${accentClasses[accent].split(' ').slice(0,2).join(' ')}`}>
      <div className="flex items-center justify-between gap-3 mb-2">
        <div className="text-slate-400 text-sm">{title}</div>
        <div className={accentClasses[accent].split(' ').slice(2).join(' ')}>{icon}</div>
      </div>
      <div className={`text-4xl font-black ${accentClasses[accent].split(' ').slice(2).join(' ')}`}>{value}</div>
      <div className="mt-3 text-sm text-slate-500">{subtitle}</div>
    </section>
  );
}

function InsightCard({ title, body, tone }: { title: string; body: string; tone: 'emerald' | 'cyan' | 'orange' | 'yellow' | 'violet' }) {
  const toneClasses = {
    emerald: 'bg-emerald-500/10 border-emerald-500/20 text-emerald-300',
    cyan: 'bg-cyan-500/10 border-cyan-500/20 text-cyan-300',
    orange: 'bg-orange-500/10 border-orange-500/20 text-orange-300',
    yellow: 'bg-yellow-500/10 border-yellow-500/20 text-yellow-300',
    violet: 'bg-violet-500/10 border-violet-500/20 text-violet-300',
  } as const;

  return (
    <div className={`rounded-xl border p-4 ${toneClasses[tone]}`}>
      <div className="font-semibold mb-1">{title}</div>
      <div className="text-sm text-slate-300">{body}</div>
    </div>
  );
}

function getContractBadgeClass(contract: string) {
  if (contract === 'Holistique 3 ans') return 'bg-cyan-500/10 text-cyan-300 border border-cyan-500/20';
  if (contract === 'À la carte') return 'bg-yellow-500/10 text-yellow-300 border border-yellow-500/20';
  if (contract === 'Loi 25') return 'bg-orange-500/10 text-orange-300 border border-orange-500/20';
  if (contract === 'Cyber 1 an') return 'bg-blue-500/10 text-blue-300 border border-blue-500/20';
  if (contract === 'SAT') return 'bg-emerald-500/10 text-emerald-300 border border-emerald-500/20';
  return 'bg-slate-500/10 text-slate-300 border border-slate-500/20';
}

function getPriorityBadgeClass(priority: string) {
  if (priority === 'Critique') return 'bg-red-500/10 text-red-300 border border-red-500/20';
  if (priority === 'Haute') return 'bg-orange-500/10 text-orange-300 border border-orange-500/20';
  return 'bg-cyan-500/10 text-cyan-300 border border-cyan-500/20';
}

function getAccentHeaderClass(accent: 'cyan' | 'violet' | 'orange' | 'emerald') {
  const classes = {
    cyan: 'border-cyan-500/20 bg-cyan-500/10 text-cyan-300',
    violet: 'border-violet-500/20 bg-violet-500/10 text-violet-300',
    orange: 'border-orange-500/20 bg-orange-500/10 text-orange-300',
    emerald: 'border-emerald-500/20 bg-emerald-500/10 text-emerald-300',
  } as const;

  return classes[accent];
}

function KanbanColumn({ title, accent, items }: { title: string; accent: 'red' | 'orange' | 'cyan'; items: readonly string[] }) {
  const headerClasses = {
    red: 'border-red-500/20 bg-red-500/10 text-red-300',
    orange: 'border-orange-500/20 bg-orange-500/10 text-orange-300',
    cyan: 'border-cyan-500/20 bg-cyan-500/10 text-cyan-300',
  } as const;

  return (
    <section className="rounded-2xl border border-slate-700 bg-[#0f172a] overflow-hidden shadow-2xl">
      <div className={`px-6 py-5 border-b ${headerClasses[accent]}`}>
        <h3 className="text-2xl font-bold">{title}</h3>
      </div>
      <div className="p-6 space-y-3">
        {items.map((item) => (
          <div key={item} className="rounded-xl border border-slate-700 bg-[#111827] p-4 text-slate-200 font-medium">
            {item}
          </div>
        ))}
      </div>
    </section>
  );
}

function RoleSection({
  title,
  subtitle,
  accent,
  items,
  columns,
}: {
  title: string;
  subtitle?: string;
  accent: 'cyan' | 'violet' | 'orange' | 'emerald';
  items: readonly string[];
  columns: string;
}) {
  const headerClasses = {
    cyan: 'border-cyan-500/20 bg-cyan-500/10 text-cyan-300',
    violet: 'border-violet-500/20 bg-violet-500/10 text-violet-300',
    orange: 'border-orange-500/20 bg-orange-500/10 text-orange-300',
    emerald: 'border-emerald-500/20 bg-emerald-500/10 text-emerald-300',
  } as const;

  const cardBorderClasses = {
    cyan: 'border-cyan-500/10 hover:border-cyan-400',
    violet: 'border-violet-500/10 hover:border-violet-400',
    orange: 'border-orange-500/10 hover:border-orange-400',
    emerald: 'border-emerald-500/10 hover:border-emerald-400',
  } as const;

  return (
    <section className="rounded-2xl border bg-[#0f172a] overflow-hidden shadow-2xl border-slate-700">
      <div className={`px-6 py-5 border-b ${headerClasses[accent]}`}>
        <h3 className="text-2xl font-bold">{title}</h3>
        {subtitle && <p className="text-slate-400 text-sm mt-1">{subtitle}</p>}
      </div>
      <div className={`p-6 grid grid-cols-1 ${columns} gap-4`}>
        {items.map((item) => (
          <div key={item} className={`rounded-xl border bg-[#111827] p-4 transition-all ${cardBorderClasses[accent]}`}>
            <div className="text-white font-medium">{item}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
